export default __webpack_public_path__ + "static/placeholder-8dd21de908bbaa53b2f4162b50906df5.png";